import { Identifiable } from "@planzone/dto";
import { Folder } from "./folder";

type Document = {
  type: "document";
  name: string;
  description: string;
  uri: string;
  createdDate: string;
  createdBy: string;
  lastModified: string;
  editedBy: string;
  vstamp: number;
  parent: Identifiable<Folder> | null;
  contentId: string;
  contentLength: number;
  mimeType: string;
  lockOwner: string;
  ancestorId: number;
  ancestralRootId: number;
  successorId: number;
  versionNumber: string;
  versionLabel: string;
};

const document: Document = {
  type: "document",
  ancestorId: 0,
  ancestralRootId: 0,
  contentId: "",
  uri: "",
  contentLength: 0,
  createdBy: "",
  createdDate: "",
  description: "",
  editedBy: "",
  lastModified: "",
  lockOwner: "",
  mimeType: "",
  name: "",
  parent: null,
  successorId: 0,
  versionLabel: "",
  versionNumber: "",
  vstamp: 0,
};

export type { Document };

export { document };
